import { WelcomeTexts } from '../../components/atomic/text/welcome_texts/WelcomeTexts';
import headerTextImg from './header_text.svg';
import descriptionTextImg from './description_text.svg';
import './Texts.css';

/** From welcome_screen_2.svg → header_text + description_text. */
export function Texts() {
  return (
    <WelcomeTexts
      titleSrc={headerTextImg}
      titleClassName="welcome-delivery-2-texts__header"
      descriptionSrc={descriptionTextImg}
      descriptionClassName="welcome-delivery-2-texts__description"
    />
  );
}
